/* luxury-motion.js — scroll reveal.
 *
 * One IntersectionObserver for the whole page, unobserving each element as
 * it fires, so nothing stays subscribed after it has been seen.
 *
 * Sections do not have to mark themselves up. autoTag() finds the parts of
 * every luxury section that should animate and tags them here, which keeps
 * the motion rules in one file instead of scattered through a dozen Liquid
 * templates. A section can still opt out with data-no-reveal, or opt in
 * explicitly with its own data-reveal.
 *
 * Anything still hidden when the observer is unavailable is revealed
 * immediately — content must never depend on JS to become visible.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Selector, then whether its children stagger as a group. */
  var TARGETS = [
    ['.luxury-sec__head', false],
    ['.luxury-split__media', false],
    ['.luxury-split__body', false],
    ['.luxury-campaign__inner', false],
    ['.luxury-manifesto__statement', false],
    ['.luxury-manifesto__support', false],
    ['.luxury-newsletter__form', false]
  ];

  var GROUPS = ['.luxury-grid', '.luxury-rail', '.luxury-gallery', '.luxury-services', '.luxury-reels__rail'];

  function autoTag(scope) {
    var sections = (scope || document).querySelectorAll('.luxury-sec:not([data-no-reveal]):not(.luxury-hero)');

    Array.prototype.forEach.call(sections, function (sec) {
      TARGETS.forEach(function (pair) {
        var els = sec.querySelectorAll(pair[0]);
        Array.prototype.forEach.call(els, function (el) {
          if (!el.hasAttribute('data-reveal') && !el.hasAttribute('data-reveal-media')) {
            el.setAttribute('data-reveal', '');
          }
        });
      });

      GROUPS.forEach(function (sel) {
        var els = sec.querySelectorAll(sel);
        Array.prototype.forEach.call(els, function (el) {
          if (!el.hasAttribute('data-reveal-group')) el.setAttribute('data-reveal-group', '70');
        });
      });
    });
  }

  function revealAll() {
    var all = document.querySelectorAll('[data-reveal], [data-reveal-media]');
    Array.prototype.forEach.call(all, function (el) {
      el.setAttribute(el.hasAttribute('data-reveal-media') ? 'data-reveal-media' : 'data-reveal', 'is-visible');
    });
  }

  if (reduce.matches || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealAll);
    else revealAll();
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var attr = el.hasAttribute('data-reveal-media') ? 'data-reveal-media' : 'data-reveal';
      el.setAttribute(attr, 'is-visible');
      observer.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function stagger(scope) {
    var groups = (scope || document).querySelectorAll('[data-reveal-group]');
    Array.prototype.forEach.call(groups, function (group) {
      var step = parseInt(group.getAttribute('data-reveal-group'), 10) || 70;
      var kids = group.children;
      for (var i = 0; i < kids.length; i++) {
        if (!kids[i].hasAttribute('data-reveal') && !kids[i].hasAttribute('data-reveal-media')) {
          kids[i].setAttribute('data-reveal', '');
        }
        // Cap the stagger so the last card in a long grid is not left waiting.
        kids[i].style.setProperty('--reveal-delay', Math.min(i * step, 420) + 'ms');
      }
    });
  }

  function init(scope) {
    autoTag(scope);
    stagger(scope);
    var els = (scope || document).querySelectorAll('[data-reveal]:not([data-reveal="is-visible"]), [data-reveal-media]:not([data-reveal-media="is-visible"])');
    Array.prototype.forEach.call(els, function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor swaps a section in without a page load.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
